export default __webpack_public_path__ + "static/media/position.3e41bab2.svg";